export const DEVICE_NOT_AUTHORISED_ERROR_CODE = 401001

export const LOCATION_CHAR = {
  WE_HAVE_SEND_EMAIL_TO_RESET_PASSWORD: 'r',
  YOUR_PASSWORD_HAS_BEN_UPDATED: 'c',
}
